module.exports = __webpack_public_path__ + "555f15860dbd067df0fc8c984fbc2b46.svg";